"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _hasChildren = _interopRequireDefault(require("./hasChildren"));

var addRowDataKeys = function addRowDataKeys(data, rowDataKey) {
  return data.map(function (row) {
    return (0, _objectSpread2.default)({}, row, {
      __key: (0, _isFunction.default)(rowDataKey) ? rowDataKey(row) : row[rowDataKey],
      children: (0, _hasChildren.default)(row) ? addRowDataKeys(row.children, rowDataKey) : []
    });
  });
};

var _default = addRowDataKeys;
exports.default = _default;